var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSamplesTemporal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H10C9.44772 9 9 8.55228 9 8C9 7.44772 9.44772 7 10 7H14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16V8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.21976V4.21C6.5 3.65771 6.94772 3.21 7.5 3.21C8.05228 3.21 8.5 3.65771 8.5 4.21V4.21976C8.5 4.77205 8.05228 5.21976 7.5 5.21976C6.94772 5.21976 6.5 4.77205 6.5 4.21976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21 7.50977V7.5C3.21 6.94772 3.65772 6.5 4.21 6.5C4.76228 6.5 5.21 6.94772 5.21 7.5V7.50977C5.21 8.06205 4.76228 8.50977 4.21 8.50977C3.65772 8.50977 3.21 8.06205 3.21 7.50977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C13.9778 2 15.9112 2.58673 17.5557 3.68555C19.2001 4.78434 20.4824 6.34567 21.2393 8.17285C21.9961 10.0001 22.1935 12.0114 21.8076 13.9512C21.4217 15.8909 20.4697 17.6728 19.0713 19.0713C17.6728 20.4697 15.8909 21.4217 13.9512 21.8076C12.0114 22.1935 10.0001 21.9961 8.17285 21.2393C6.34567 20.4824 4.78434 19.2001 3.68555 17.5557C2.58673 15.9112 2 13.9778 2 12C2 11.4477 2.44772 11 3 11C3.55228 11 4 11.4477 4 12C4 13.5823 4.46958 15.1287 5.34863 16.4443C6.22764 17.7599 7.47676 18.7851 8.93848 19.3906C10.4002 19.9961 12.0088 20.1553 13.5605 19.8467C15.1124 19.538 16.5384 18.776 17.6572 17.6572C18.776 16.5384 19.538 15.1124 19.8467 13.5605C20.1553 12.0088 19.9961 10.4002 19.3906 8.93848C18.7851 7.47676 17.7599 6.22764 16.4443 5.34863C15.1287 4.46958 13.5823 4 12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamplesTemporal);
export default __webpack_public_path__ + "static/media/samples-temporal.cce5b449c05ff6e8873154c6472504d3.svg";
export { ForwardRef as ReactComponent };